/* eslint-disable @typescript-eslint/no-explicit-any */
import { Component } from '@angular/core';
import { MenuItem, MessageService } from 'primeng/api';
import { Subscription } from 'rxjs';
import { IDialogMessage } from 'src/app/@amiga-pyme/components/ami-dialog-message/ami-dialog-message.interface';
import { CashRegisterActiveUserService } from '../cash-register/cash-register-active-user.service';
import { CartSaleService } from './components-aux/cart/cart-sale.service';
import {
  PaymentMethodType,
  TFormatBoughtInCar,
  VoucherType
} from './sales.interface';
import {
  getTotalCostOfBoughtFormats,
  getTotalMinUnitsBought
} from './sales.utils';
import { ClientSaleService } from './steps/client/client-sale.service';
import { MoneyBackSaleService } from './steps/money-back/money-back-sale.service';
import { PaymentSaleService } from './steps/payment/payment-sale.service';
import { ReceiptSaleService } from './steps/receipt/receipt-sale.service';
import { SalesService } from './steps/sales.service';
import * as QRCode from 'qrcode';

@Component({
  selector: 'pg-sales-component',
  templateUrl: './sales.component.html',
  providers: [MessageService]
})
export class SalesComponent {
  dataForVoucher: any;
  isDialogVoucherOpen = false;

  message: IDialogMessage;
  items: MenuItem[];
  activeIndex = 0;
  itemToSideBar: any;
  openSideBar = false;
  branchStoreId = null;
  qrCodeImage: string;

  private showBackMoney = false;
  private amountSale = 0;
  private methodPaymentId = PaymentMethodType.EFECTIVO;
  private methodPaymentName = '';
  private subscriptionPaymentService: Subscription = new Subscription();
  constructor(
    public messageService: MessageService,
    private cartSaleService: CartSaleService,
    private paymentSaleService: PaymentSaleService,
    private receiptSaleService: ReceiptSaleService,
    private clientSaleService: ClientSaleService,
    private salesService: SalesService,
    private cashRegisterActiveUserService: CashRegisterActiveUserService,
    private moneyBackSaleService: MoneyBackSaleService
  ) {}

  ngOnInit() {
    this.items = [
      {
        label: 'Productos'
      },
      {
        label: 'Confirmación'
      }
    ];

    this.cashRegisterActiveUserService.getData$().subscribe((data: any) => {
      const { branchStoreId } = data;
      this.branchStoreId = branchStoreId;
    });
    this.subscriptionPaymentService = this.paymentSaleService
      .getData()
      .subscribe((data) => {
        this.methodPaymentId = PaymentMethodType[data.name];
        this.methodPaymentName = data.name;
        this.showBackMoney =
          this.methodPaymentId === PaymentMethodType.EFECTIVO;
      });
    this.cartSaleService.getData$().subscribe(() => {
      this.amountSale = this.cartSaleService.getTotalAmount();
    });
  }

  isCartEmpty() {
    return this.cartSaleService.isCartEmpty();
  }

  prevPage() {
    this.activeIndex--;
  }
  nextPage() {
    this.activeIndex++;
  }

  async confirmSale() {
    const productsBody = this.buildProductsBody();
    const documentBody = this.buildDocumentBody();

    if (!documentBody) {
      return;
    }

    const request = {
      document: documentBody,
      products: productsBody
    };

    if (this.isNotaVentaNotAllowed(request.document)) {
      return;
    }

    if (this.isClientRequired(request.document)) {
      return;
    }

    if (this.isRUCRequired(request.document)) {
      return;
    }

    if (this.isInsufficientPayment(request.document)) {
      return;
    }

    this.message = { message: 'Registrando venta...' };

    const { data, ...message } = await this.salesService.register(request);
    this.message = message;
    const status = this.message.status;

    if (status === 201) {
      this.processSuccessfulSale(data);
    }
  }

  private showWarningMessage(summary: string, detail: string) {
    this.messageService.add({
      severity: 'warn',
      summary: summary,
      detail: detail
    });
  }

  private isNotaVentaNotAllowed(document: any): boolean {
    if (
      document.typeVoucherId === VoucherType['NOTA VENTA'] &&
      document.amount > 700
    ) {
      this.showWarningMessage(
        'Nota de Venta no permitida',
        'Las Notas de Venta no pueden ser mayores o iguales a 700, para montos mayores se requiere que sea una Boleta o Factura'
      );
      return true;
    }
    return false;
  }

  private isClientRequired(document: any): boolean {
    if (
      !document.clientId &&
      document.typeVoucherId !== VoucherType['NOTA VENTA']
    ) {
      this.showWarningMessage(
        'Es necesario un cliente registrado',
        'Para emitir una Boleta o Factura es necesario que el cliente esté registrado'
      );
      return true;
    }
    return false;
  }

  private isRUCRequired(document: any): boolean {
    if (
      document.typeVoucherId === VoucherType.FACTURA &&
      document.clientDocumentType !== 'RUC'
    ) {
      this.showWarningMessage(
        'Es necesario un RUC',
        'Para emitir una Factura es necesario que el cliente tenga un RUC'
      );
      return true;
    }
    return false;
  }

  private isInsufficientPayment(document: any): boolean {
    if (
      document.methodPaymentId === PaymentMethodType.EFECTIVO &&
      document.payWith < document.amount
    ) {
      this.showWarningMessage(
        'Pago insuficiente',
        'El Pago del Cliente es menor al Monto de la Venta'
      );
      return true;
    }
    return false;
  }

  private processSuccessfulSale(data: any) {
    this.generateQRCode(data);
    this.dataForVoucher = data;
    this.dataForVoucher.qrCodeImage = this.qrCodeImage;
    this.dataForVoucher.methodPaymentName = this.methodPaymentName;
    setTimeout(() => {
      this.cartSaleService.emptyData();
      this.clientSaleService.emptyData();
      this.isDialogVoucherOpen = true;
      this.activeIndex = 0;
      this.message = undefined;
    }, 1500);
  }

  private generateQRCode(data: any) {
    const { document } = data;
    const date = new Date(document.createdAt);
    const day = date.getDate();
    const month = date.getMonth() + 1;
    const year = date.getFullYear();
    const formattedDate = `${year}-${month}-${day}`;
    const parseDate =
      `${document.businessRuc}|` +
      `${document.billSaleTypeVoucher}|` +
      `${document.amount}|` +
      `${formattedDate}|` +
      `${document.pointSaleSerieNumber}|` +
      `${document.clientIdNumber}`;
    const qrData = JSON.stringify(parseDate);
    QRCode.toDataURL(qrData, this.handleQRCodeGeneration.bind(this));
  }

  private handleQRCodeGeneration(err: any, url: string) {
    if (err) {
      console.error(err);
    } else {
      this.qrCodeImage = url;
    }
  }

  private buildDocumentBody(): any {
    const receiptDetails = this.receiptSaleService.getData();
    const clientDetails = this.clientSaleService.getData();
    const totalAmount = this.cartSaleService.getTotalAmount();
    const moneyBackData = this.moneyBackSaleService.getData();

    if (!clientDetails) {
      this.showWarningMessage(
        'No se seleccionó cliente',
        'Seleccionar un cliente registrado o cliente default'
      );
      return;
    }

    const methodPaymentId = this.methodPaymentId;
    const isCashPayment = methodPaymentId === PaymentMethodType.EFECTIVO;
    const payWith = isCashPayment ? moneyBackData.amountPaid : totalAmount;

    return {
      payWith,
      clientId: clientDetails.id,
      clientDocumentType: clientDetails.identifier,
      typeVoucherId: VoucherType[receiptDetails.name],
      typeMoneyId: 1,
      methodPaymentId,
      amount: totalAmount,
      expAt: '2025-05-30'
    };
  }

  private buildProductsBody(): any[] {
    const cartData = this.cartSaleService.getData();

    const productsBoughtBody = cartData.map((stockProductBought) => {
      const formatsBought = stockProductBought.formatsSelled;
      const totalCostOfBoughtFormats =
        getTotalCostOfBoughtFormats(formatsBought);
      const quantityMSU = getTotalMinUnitsBought(
        formatsBought,
        stockProductBought.format
      );

      const formatsBody = this.buildFormatsBody(formatsBought);

      return {
        priceMSU: totalCostOfBoughtFormats / quantityMSU,
        quantityMSU,
        withIgv: 1,
        productId: stockProductBought.productId,
        typeProductId: stockProductBought.typeProductId,
        codeProduct: stockProductBought.productCode.toString(),
        amount: totalCostOfBoughtFormats,
        lot: stockProductBought.lot,
        description: stockProductBought.productName,
        expAt: stockProductBought.expAt,
        formats: { ...formatsBody }
      };
    });

    return productsBoughtBody;
  }

  private buildFormatsBody(formatsBought: any): any {
    const formatsBody = {};

    for (const [format, formatData] of Object.entries(formatsBought)) {
      const typedFormatData = formatData as TFormatBoughtInCar;

      if (typedFormatData) {
        formatsBody[format] = {
          cantidad: typedFormatData.quantityInCart,
          precio: typedFormatData.precio,
          purchasePrice: typedFormatData.purchasePrice,
          profitMargin: Number(typedFormatData.profitMargin).toFixed(2),
        };
      }
    }

    return formatsBody;
  }

  ngOnDestroy() {
    this.cartSaleService.emptyData();
    this.subscriptionPaymentService.unsubscribe();
  }
}
